<template>
  <div
    class="cursor-pointer duration-300 ease-in-out text-center flex flex-col "
    @click="$emit('click')"
  >
    <div
      class="uppercase text-2xl lg:text-2xl leading-none hidden tracking-wider md:block font-bold hover:text-darkFont"
      :class="[selected ? `text-darkFont` : 'text-lightFont']"
    >
      {{ dayOfWeek }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ScheduleDate",
  props: {
    dayOfWeek: {
      type: String,
      required: true
    },
    day: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
  }
};
</script>

<style scoped></style>
